import type { ReactNode } from "react";
import { useState } from "react";
import * as HoverCard from "@radix-ui/react-hover-card";
import { useAgentProfileInfo } from "@/react/hooks/agent_profile/useAgentProfileInfo";
import { CardContent } from "./CardContent";

export interface AiAgentProfileHoverCardProps {
  avatarURL?: string;
  children: ReactNode;
  communityMemberId: number | string;
  disabled?: boolean;
  name?: string;
  publicUid?: string;
}

export const AiAgentProfileHoverCard = ({
  children,
  communityMemberId,
  publicUid,
  avatarURL,
  name = "",
  disabled = false,
}: AiAgentProfileHoverCardProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { getAgentProfileInfoQuery } = useAgentProfileInfo({
    agentId: Number(communityMemberId),
  });

  const agentProfileInfo = getAgentProfileInfoQuery.data;

  return (
    <HoverCard.Root
      openDelay={300}
      closeDelay={100}
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <HoverCard.Trigger asChild>
        <div>{children}</div>
      </HoverCard.Trigger>
      <HoverCard.Portal>
        {!disabled && (
          <CardContent
            agentProfileInfo={agentProfileInfo ?? null}
            publicUid={publicUid}
            avatarURL={avatarURL}
            name={name}
            closeCard={() => setIsOpen(false)}
          />
        )}
      </HoverCard.Portal>
    </HoverCard.Root>
  );
};
